<template>
  <v-container fluid id="MyServiceRequests" class="pa-0 pa-sm-3">
    <v-row wrap>
      <v-col cols="12" xs="12" class="headline pb-0">
        Truck Service Requests
      </v-col>
      <v-col cols="12" xs="12" class="">
        <v-card>
          <v-tabs>
            <v-tab @click="truckServiceRequestType('open')">Open</v-tab>
            <v-tab @click="truckServiceRequestType('closed')">Closed</v-tab>
            <v-tab @click="truckServiceRequestType('cancelled')"
              >Cancelled</v-tab
            >
          </v-tabs>
          <v-divider></v-divider>
          <v-data-table
            :items="currentTruckServiceRequests"
            :loading="loadingTruckServiceRequests"
            :search="search"
            loading-text="Loading....please wait."
            :headers="computedHeaders"
            :items-per-page="20"
            sort-by="orderDate"
            sort-desc
          >
            <template v-slot:top>
              <v-toolbar flat color="white" class="pt-1">
                <v-text-field
                  outlined
                  dense
                  hide-details
                  v-model="search"
                  append-icon="search"
                  label="Filter by address"
                ></v-text-field>
              </v-toolbar>
            </template>
            <template v-slot:item.orderNumber="{ item }">
              <span class="subtitle-2">#{{ item.orderNumber }}</span>
            </template>
            <template v-slot:item.truck="{ item }">
              {{ item.truck }}<br />
              <v-chip color="error" class="mr-2" x-small v-if="item.down"
                >Down</v-chip
              >
              <v-chip color="amber" x-small v-if="item.roadCall"
                >Road Call</v-chip
              >
            </template>
            <template v-slot:item.photos="{ item }">
              <service-photos :photos="item.photos" />
            </template>
            <template v-slot:item.orderDate="{ item }">
              {{ item.orderDate.toDate() | moment("MMM Do h:mma") }}
            </template>
            <template v-slot:item.status="{ item }">
              <status-chip :status="item.status" />
            </template>
            <template v-slot:item.closingNotes="{ item }">
              <div class="caption" v-if="item.status == 'closed'">
                Mechanic: <strong>{{ item.mechanicName }}</strong
                ><br />
                Man Hours: <strong>{{ item.manHours }}</strong
                ><br />
                Estimated Cost: <strong>${{ item.estimatedCost }}</strong
                ><br />
                Date:
                <strong>{{
                  item.closeDate.toDate() | moment("MMM Do h:mma")
                }}</strong
                ><br />
                By:
                <strong
                  >{{ item.closedBy.firstName }}
                  {{ item.closedBy.lastName }}</strong
                ><br />
                Notes: <strong>{{ item.closingNotes }}</strong>
              </div>
            </template>
            <template v-slot:item.details="{ item }">
              <v-btn
                v-if="item.status == 'open'"
                color="primary"
                class="mb-1 mr-2"
                small
                outlined
                text
                @click.stop="closeRequest(item)"
                >close</v-btn
              >
              <v-btn
                v-if="item.status == 'open'"
                color="primary"
                class="mb-1"
                small
                outlined
                text
                @click.stop="cancelDialogOpen(item)"
                >Cancel</v-btn
              >
            </template>
            <template v-slot:item.down="{ item }">
              <v-checkbox
                v-if="item.status == 'open'"
                @change="upDown(item)"
                v-model="item.down"
                label=""
              ></v-checkbox>
            </template>
            <template v-slot:item.roadCall="{ item }">
              <v-checkbox
                v-if="item.status == 'open'"
                @change="roadCallSwitch(item)"
                v-model="item.roadCall"
                label=""
              ></v-checkbox>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-snackbar v-model="snack" :timeout="2000" :color="snackColor">
      {{ snackText }}
      <v-btn text @click="snack = false">Close</v-btn>
    </v-snackbar>
    <v-dialog v-model="dialog" width="500">
      <v-card v-if="currentRequest">
        <v-card-title primary-title>
          Close Service Request
        </v-card-title>
        <v-card-text>
          <v-simple-table dense class="order-details-table mt-3">
            <template v-slot:default>
              <tbody>
                <tr>
                  <td class="pa-1 pl-0 grey--text" valign="top" width="85">
                    Truck:
                  </td>
                  <td>
                    {{ currentRequest.truck }}
                  </td>
                </tr>
                <tr>
                  <td class="pa-1 pl-0 grey--text" valign="top" width="85">
                    Date:
                  </td>
                  <td>
                    {{
                      currentRequest.orderDate.toDate() | moment("MMM Do h:mma")
                    }}
                  </td>
                </tr>
                <tr>
                  <td class="pa-1 pl-0 grey--text" valign="top" width="85">
                    Ordered By:
                  </td>
                  <td>
                    {{ currentRequest.orderedBy.firstName }}
                    {{ currentRequest.orderedBy.lastName }}
                  </td>
                </tr>
                <tr>
                  <td class="pa-1 pl-0 grey--text" valign="top" width="85">
                    Description:
                  </td>
                  <td>
                    {{ currentRequest.notes }}
                  </td>
                </tr>
                <tr v-if="currentRequest.photos && currentRequest.photos.length">
                  <td class="pa-1 pl-0 grey--text" valign="top" width="85">
                    Photos:
                  </td>
                  <td class="py-1">
                    <service-photos :photos="currentRequest.photos" :size="80" />
                  </td>
                </tr>
                <tr>
                  <td class="pa-1 pl-0 grey--text" valign="top" width="85">
                    Estimated Cost:
                  </td>
                  <td>
                    <v-text-field
                      outlined
                      class="mt-1"
                      type="number"
                      dense
                      v-model.number="currentRequest.estimatedCost"
                    ></v-text-field>
                  </td>
                </tr>
                <tr>
                  <td class="pa-1 pl-0 grey--text" valign="top" width="85">
                    Mechanic:
                  </td>
                  <td>
                    <v-text-field
                      outlined
                      class="mt-1"
                      dense
                      v-model="currentRequest.mechanicName"
                    ></v-text-field>
                  </td>
                </tr>
                <tr>
                  <td class="pa-1 pl-0 grey--text" valign="top" width="85">
                    Man Hours:
                  </td>
                  <td>
                    <v-text-field
                      outlined
                      class="mt-1"
                      type="number"
                      dense
                      v-model.number="currentRequest.manHours"
                    ></v-text-field>
                  </td>
                </tr>
                <tr>
                  <td class="pa-1 pl-0 grey--text" valign="top" width="85">
                    Closing Notes:
                  </td>
                  <td>
                    <v-textarea
                      outlined
                      class="mt-1"
                      v-model="currentRequest.closingNotes"
                      dense
                    ></v-textarea>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
        <v-card-actions class="align-right pa-4">
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="dialog = false" class="mr-2"
            >Cancel</v-btn
          >
          <v-btn color="primary" @click="updateRequest">Close Request</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="cancelDialog" width="500">
      <v-card v-if="currentRequest">
        <v-card-title primary-title>
          Cancel Service Request
        </v-card-title>
        <v-card-text>
          <v-simple-table dense class="order-details-table mt-3">
            <template v-slot:default>
              <tbody>
                <tr>
                  <td class="pa-1 pl-0 grey--text" valign="top" width="85">
                    Truck:
                  </td>
                  <td>
                    {{ currentRequest.truck }}
                  </td>
                </tr>
                <tr>
                  <td class="pa-1 pl-0 grey--text" valign="top" width="85">
                    Date:
                  </td>
                  <td>
                    {{
                      currentRequest.orderDate.toDate() | moment("MMM Do h:mma")
                    }}
                  </td>
                </tr>
                <tr>
                  <td class="pa-1 pl-0 grey--text" valign="top" width="85">
                    Ordered By:
                  </td>
                  <td>
                    {{ currentRequest.orderedBy.firstName }}
                    {{ currentRequest.orderedBy.lastName }}
                  </td>
                </tr>
                <tr>
                  <td class="pa-1 pl-0 grey--text" valign="top" width="85">
                    Description:
                  </td>
                  <td>
                    {{ currentRequest.notes }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
        <v-card-actions class="align-right pa-4">
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="cancelDialog = false" class="mr-2"
            >Cancel</v-btn
          >
          <v-btn color="primary" @click="cancelRequest">Cancel Request</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import fb from "@/main";
import { mapState } from "vuex";
import statusChip from "@/components/StatusChip";
import servicePhotos from "@/components/truckRequests/servicePhotos";
export default {
  components: {
    statusChip,
    servicePhotos,
  },
  data() {
    return {
      search: "",
      type: "open",
      dialog: false,
      cancelDialog: false,
      loadingTruckServiceRequests: true,
      truckServiceRequests: [],
      snack: false,
      snackColor: "",
      snackText: "",
      currentRequest: null,
      headers: [
        {
          text: "Order",
          align: "left",
          value: "orderNumber",
          sortable: false,
          width: 60,
        },
        { text: "Truck", value: "truck" },
        { text: "Description", value: "notes", width: 300 },
        { text: "Photos", value: "photos", sortable: false, width: 140 },
        { text: "Request Date", value: "orderDate" },
        { text: "Requested By", value: "orderedByFullName" },
        { text: "Closing Notes", value: "closingNotes" },
        { text: "Status", value: "status", align: "center" },
        { text: "", value: "details", align: "right" },
        { text: "Down?", value: "down", align: "left" },
        { text: "Road Call", value: "roadCall", align: "left" },
      ],
    };
  },
  computed: {
    currentTruckServiceRequests: function() {
      return this.truckServiceRequests.filter((wo) => wo.status == this.type);
    },
    ...mapState(["user"]),
    computedHeaders() {
      if (this.type === "open") {
        return this.headers.filter((h) => h.value !== "closingNotes");
      } else {
        return this.headers.filter((h) => {
          return !["down", "roadCall"].includes(h.value);
        });
      }
    },
  },
  async created() {
    this.unsubscribeTruckService = await fb.db
      .collection("truckService")
      .onSnapshot((t) => {
        var truckService = [];
        t.forEach(function(doc) {
          truckService.push({
            ...doc.data(),
          });
        });
        this.truckServiceRequests = truckService.map((t) => {
          return {
            orderedByFullName: `${t.orderedBy.firstName} ${t.orderedBy.lastName}`,
            ...t,
          };
        });
        this.loadingTruckServiceRequests = false;
      });
  },
  methods: {
    closeRequest(request) {
      this.currentRequest = null;
      this.currentRequest = { ...request };
      this.dialog = true;
    },
    cancelDialogOpen(request) {
      this.currentRequest = null;
      this.currentRequest = { ...request };
      this.cancelDialog = true;
    },
    truckServiceRequestType(type) {
      this.type = type;
    },
    async updateRequest() {
      try {
        await fb.db
          .collection("truckService")
          .doc(this.currentRequest.orderNumber)
          .update({
            mechanicName: this.currentRequest.mechanicName || "",
            manHours: this.currentRequest.manHours || 0,
            estimatedCost: this.currentRequest.estimatedCost || 0,
            closingNotes: this.currentRequest.closingNotes || "",
            status: "closed",
            closeDate: fb.timestamp,
            closedBy: this.user,
          });
        this.dialog = false;
        this.snack = true;
        this.snackColor = "success";
        this.snackText = "Successfully updated service request!";
        const truckServiceEmails = await fb.functions.httpsCallable(
          "truckServiceEmails"
        );
        truckServiceEmails(this.currentRequest);
      } catch (error) {
        this.snack = true;
        this.snackColor = "error";
        this.snackText = "Error updating service request!";
      }
    },
    async cancelRequest() {
      try {
        await fb.db
          .collection("truckService")
          .doc(this.currentRequest.orderNumber)
          .update({ status: "cancelled" });
        this.cancelDialog = false;
        this.snack = true;
        this.snackColor = "success";
        this.snackText = "Successfully updated service request!";
      } catch (error) {
        this.snack = true;
        this.snackColor = "error";
        this.snackText = "Error updating service request!";
      }
    },
    async upDown(item) {
      try {
        await fb.db
          .collection("truckService")
          .doc(item.orderNumber)
          .update({ down: item.down });
      } catch (error) {
        this.snack = true;
        this.snackColor = "error";
        this.snackText = "Error updating service request!";
      }
    },
    async roadCallSwitch(item) {
      try {
        await fb.db
          .collection("truckService")
          .doc(item.orderNumber)
          .update({ roadCall: item.roadCall });
      } catch (error) {
        this.snack = true;
        this.snackColor = "error";
        this.snackText = "Error updating service request!";
      }
    },
    beforeDestroy() {
      this.unsubscribeTruckService();
    },
  },
};
</script>
